import Sonda from "@gcloud-npm/utils.monitoring.sonda";
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";
import Request from "@/utils/fetch";
import {
  makeUpTelcoPathName,
  getAdabyronConstants,
  PROCESS_NAME,
} from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import { calculateHeaderParams } from "@gcloud-npm/node.build-process.build-environments";
import { FAMILY_API } from "@gcloud-npm/utils.enums.environment";
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';

const PATH = 'productos/serviciosterceros/smartwifi/estado';
const EVENT_NAME = 'THIRD_PARTIES/GET_SMART_WIFI_STATUS';
const METHOD = 'POST';

export const getSmartWiFiStatus = ({
  data,
  context,
  idFront = 'VT',
  build = false,
  version,
  onRedirect,
}) => {
  const { environment, userType } = context;
  const { telco: connectionData } = environment;
  const { endpoint: host } = connectionData;

  const idRequest = getUUID(idFront);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);
  const { prefixToApply } = getAdabyronConstants(userType);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME.CLIENT,
  });

  let queryParams = [];

  let urlParamsToReplace = [];

  const URL_API = makeUpTelcoPathName({
    path: PATH,
    version,
    idRequest,
    host,
    prefixToApply,
    queryParams,
    urlParamsToReplace,
  });

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    headers: {
      ...headers2Use,
      "Content-Type": "application/json;charset=utf-8",
    },
    data,
    sonda,
    onRedirect: onRedirect || sendToRelogin,
  });
  
  return request.makeRequest();
};

export default getSmartWiFiStatus;
